export default {
    /**
     * @param {number} num
     * @param {number} limit
     *
     * @returns {number}
     */
    lowerBound(num, limit) {
        return num >= limit ? num : limit;
    },

    /**
     * @param {string} str
     * @param {boolean} is_xhtml
     *
     * @returns {string}
     */
    nl2br(str, is_xhtml) {
        const breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        
        return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
    },

    /**
     *
     * @param {array} array
     *
     * @returns {boolean}
     */
    arrayHasDuplicates(array) {
        const valuesSoFar = Object.create(null);

        for (let i = 0; i < array.length; ++i) {
            const value = array[i];

            if (value in valuesSoFar) {
                return true;
            }
            valuesSoFar[value] = true;
        }

        return false;
    }
};



// WEBPACK FOOTER //
// ./src/services/Utils.js